<template>
    <div class="relative flex items-end">
        <img src="/static/img/mascot/z.png" alt="Tood" width="70px" class="mr-4">
        <div class="bubble px-4 py-2 leading-normal">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>


// WEBPACK FOOTER //
// src/components/Patient/Bubble.vue